import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@kontentino/ui';
import routes from 'constants/routes';
import { createSearchFromParams } from 'utils/url';
import NotificationsFeed from 'app/modules/inAppNotifications/components/NotificationsFeed';

type Props = {
  onRequestClose: () => void;
};

function NotificationsTooltipContent({ onRequestClose }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <NotificationsFeed
      footer={({ tab, filter }) => (
        <div className="tw-px-4 tw-pb-4">
          <Button
            variant="secondary"
            size="small"
            className="tw-w-full"
            onClick={() => {
              onRequestClose();
              navigate({
                pathname: routes.IN_APP_NOTIFICATIONS,
                search: createSearchFromParams({ tab, filter }),
              });
            }}
            data-cy="navbar_notifications_show-all"
          >
            {t('notifications.seeAll')}
          </Button>
        </div>
      )}
    />
  );
}

export default NotificationsTooltipContent;
